export default function randomChoiceFromArray(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}